import styled from 'styled-components';

import { BodySmallRegular, BodyStandardSemiBold, Colour } from '@xemplo/style-constants';

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
  gap: 12px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;

  &.role {
    margin-top: 24px;
    grid-template-columns: 1fr 1fr 20%;
  }
`;

export const Legend = styled.div`
  ${BodyStandardSemiBold};
  color: ${Colour.Gray[800]};
  margin-bottom: 24px;
  display: flex;
  gap: 24px;
  flex-direction: column;
  grid-column: 1/-1;
`;

export const Label = styled.label`
  ${BodySmallRegular};
  color: ${Colour.Gray[700]};
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RadioGroupTitle = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[700]};
`;
